import { NewMatchCommon } from '@/components/add-match'

export const NewMatch = () => {
  return <NewMatchCommon />
}
